var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 22,
    viewBox: "0 0 31 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 29,
    height: 21,
    rx: 3.5,
    stroke: "#8687E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1666 12.1667C20.266 12.1666 20.3637 12.1412 20.4505 12.0928C20.5373 12.0443 20.6103 11.9745 20.6625 11.89C20.7148 11.8054 20.7445 11.7089 20.749 11.6096C20.7535 11.5103 20.7325 11.4115 20.6881 11.3226L19.6521 9.25002L20.6881 7.17744C20.7325 7.08853 20.7535 6.98973 20.749 6.89044C20.7445 6.79115 20.7148 6.69464 20.6625 6.61008C20.6103 6.52553 20.5373 6.45572 20.4505 6.40729C20.3637 6.35886 20.266 6.33341 20.1666 6.33335H13.7499V5.75002C13.7499 5.59531 13.6885 5.44694 13.5791 5.33754C13.4697 5.22815 13.3213 5.16669 13.1666 5.16669C13.0119 5.16669 12.8635 5.22815 12.7541 5.33754C12.6447 5.44694 12.5833 5.59531 12.5833 5.75002V16.25C12.5833 16.4047 12.6447 16.5531 12.7541 16.6625C12.8635 16.7719 13.0119 16.8334 13.1666 16.8334C13.3213 16.8334 13.4697 16.7719 13.5791 16.6625C13.6885 16.5531 13.7499 16.4047 13.7499 16.25V12.1667H20.1666Z",
    fill: "#F43F3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.347efbd1588b671ac7b0b2358839ee99.svg";
export { ForwardRef as ReactComponent };